export default __webpack_public_path__ + "static/media/3-card.104d81c3.png";